// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"20":"d326d94b1f80ca64","278":"c42d9be20285545b"}[chunkId] + ".js";
};